
import { Component, Vue, Prop } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * モーダル風画面レイアウト
 */
@Component({
  components: {
    PanelFrame,
  },
})
export default class ModalStylePageLayout extends Vue {
  /**
   * パネルの高さを調節
   *   true:画面サイズに合わせて伸縮(パネル内スクロール)
   *   false(デフォルト):中身に合わせて伸縮(画面スクロール)
   */
  @Prop({ default: false })
  private adjustHeight!: boolean
}
